import React from 'react';
import {
  Box,
  Chip,
  IconButton,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ListNavigation from '../ListNavigation';
import ClientTagsRow from '../clients/ClientTagsRow';

export default function ClientDetailHeader({
  client,
  clientName,
  isMobile,
  navIds,
  navIndex,
  onBack,
  onPrev,
  onNext,
  clientItemsTotal,
  detailContext,
}) {
  const { t } = useTranslation();

  const openChecks = client?.openChecksCount ?? 0;
  const unassigned = client?.unassignedItemsCount ?? 0;

  return (
    <Paper sx={{ p: { xs: 1.5, sm: 2 }, mb: 2 }}>
      <Box display="flex" alignItems="flex-start" gap={1}>
        <IconButton onClick={onBack} size={isMobile ? 'small' : 'medium'} sx={{ mt: 0.25 }}>
          <BackIcon />
        </IconButton>
        <Box sx={{ mt: 0.25 }}>
          <ListNavigation ids={navIds} index={navIndex} onPrev={onPrev} onNext={onNext} />
        </Box>
        <Box flex={1} minWidth={0}>
          <Typography variant={isMobile ? 'h5' : 'h4'} fontWeight="bold" noWrap>
            {clientName}
          </Typography>
          {detailContext && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {detailContext}
            </Typography>
          )}
          {(client?.clientTags || []).length > 0 && (
            <ClientTagsRow tags={client.clientTags} maxVisible={isMobile ? 4 : 8} sx={{ mt: 0.75 }} />
          )}
          <Stack direction="row" flexWrap="wrap" gap={0.75} sx={{ mt: 1 }}>
            <Chip
              size="small"
              variant="outlined"
              label={t('clients.profile.summaryItems', { count: clientItemsTotal })}
            />
            {openChecks > 0 && (
              <Chip
                size="small"
                color="warning"
                variant="outlined"
                label={t('clients.profile.summaryOpenChecks', { count: openChecks })}
              />
            )}
            {unassigned > 0 && (
              <Chip
                size="small"
                color="error"
                variant="outlined"
                label={t('clients.profile.summaryUnassigned', { count: unassigned })}
              />
            )}
          </Stack>
        </Box>
      </Box>
    </Paper>
  );
}
